import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ellipse",
  width: "133",
  height: "139",
  viewBox: "0 0 133 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "95",
  cy: "44",
  r: "75",
  stroke: "url(#paint0_radial_1522_20363)",
  "stroke-width": "40"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "paint0_radial_1522_20363",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 32.5) rotate(44.3069) scale(175.375)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      "stop-color": "#DF394B",
      "stop-opacity": "0.98"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#FA5D6D",
      "stop-opacity": "0"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "ellipse",
  width: "133",
  height: "139",
  viewBox: "0 0 133 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "95",
  cy: "44",
  r: "75",
  stroke: "url(#paint0_radial_1522_20352)",
  "stroke-width": "40"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "paint0_radial_1522_20352",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 32.5) rotate(44.3069) scale(175.375)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#5886FE" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#759CFE"
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "ellipse",
  width: "133",
  height: "139",
  viewBox: "0 0 133 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "95",
  cy: "44",
  r: "75",
  stroke: "url(#paint0_radial_1522_20342)",
  "stroke-width": "40"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "paint0_radial_1522_20342",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 32.5) rotate(44.3069) scale(175.375)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#25BBB4" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#1EC9C1"
    })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "ellipse",
  width: "133",
  height: "139",
  viewBox: "0 0 133 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "95",
  cy: "44",
  r: "75",
  stroke: "url(#paint0_radial_1522_20373)",
  "stroke-width": "40"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "paint0_radial_1522_20373",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 32.5) rotate(44.3069) scale(175.375)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#6C1B81" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#D632FF"
    })
  ])
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "widget-content d-flex align-items-center justify-content-between w-100" }
const _hoisted_18 = { class: "count" }
const _hoisted_19 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: _normalizeClass(`widget-total-agency ${_ctx.color}`)
  }, [
    (_ctx.color == 'red')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.color == 'blue')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.color == 'green')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.color == 'purple')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.count), 1),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.text), 1)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(`${_ctx.icon} fa-3x icon`)
      }, null, 2)
    ])
  ], 2))
}